import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useAcknowledgePolicy(policyId: string | undefined) {
  const queryClient = useQueryClient();
  const { profile } = useAuth();

  return useMutation({
    mutationFn: async (policyVersionId: string) => {
      if (!profile?.id) throw new Error('User profile not found');

      const { error } = await supabase
        .from('policy_acknowledgements')
        .insert({
          policy_version_id: policyVersionId,
          acknowledged_by: profile.id,
        });

      if (error) {
        if (error.code === '23505') {
          throw new Error('You have already acknowledged this version');
        }
        throw error;
      }
    },
    onSuccess: () => {
      toast.success('Policy acknowledged successfully');
      queryClient.invalidateQueries({ queryKey: ['policy-acknowledgements', policyId] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to acknowledge policy');
    },
  });
}
